import { all, call, put, select, takeEvery } from "redux-saga/effects";
import { decodeURL, isRfpPending, extractUrlParams } from "../../utils/common";

import {
  CONTINUE_TRANSACTION,
  TRANSACTION_STATUS,
} from "./types";

import URLs from "../../constants/urls";
import {
  TRANSACTION_STATE,
} from "../../constants/status";

import {
  getRequest
} from "../../services/request";

import {
  setParams,
  continueTransactionSuccess,
  continueTransactionFailure,
  transactionStatusSuccess,
  transactionStatusVerify,
  transactionStatusFailure,
  transactionStatusPending,
  showLoading,
  hideLoading,
} from "./actions";

import { isSuccessStatus } from "../../utils/common";
import { getXAuthToken } from '../../utils/sessionStorage';

function* continueTransactionCall(action) {
  try {
    yield put(setParams({ code: action.response.code, merchantReturnUrl: action.response.merchantReturnUrl }));
    const response = yield call(getRequest, URLs.CONTINUE_TRANSACTION, action.response.code);
    yield put(showLoading());
    if (response && isSuccessStatus(response.status)) {
      if (response.data.error) {
        yield put(continueTransactionFailure(response.data.error));
        return;
      }
      yield put(hideLoading());
      yield put(continueTransactionSuccess(response.data));
    } else {
      yield put(continueTransactionFailure());
    }
  } catch (err) {}
}

function* transactionStatusCall(action) {
  try {
    const stateApp = yield select((state) => state.app);
    const response = yield call(getRequest, URLs.GET_TRANSACTION_STATUS, stateApp.xAuthToken || getXAuthToken());

    if (response && isSuccessStatus(response.status)) {
      const { data } = response;
      const merchantReturnUrlParams = extractUrlParams(decodeURL(data.obvRedirectUrl || ""));
      if (
          !stateApp.rfpMonitoring && data.status === TRANSACTION_STATE.WAITING_FOR_VERIFICATION &&
          (action.timestamp === merchantReturnUrlParams.timestamp || stateApp.timestamp === merchantReturnUrlParams.timestamp)
        ) {
          yield put(transactionStatusPending(data));
          return;
      }
      switch (data.status) {
        case TRANSACTION_STATE.SUCCESS:
          yield put(transactionStatusSuccess(data));
          return;
        case TRANSACTION_STATE.WAITING_FOR_VERIFICATION:
          if (stateApp.rfpMonitoring && isRfpPending(stateApp.transactionState)) {
            return;
          }
          yield put(transactionStatusVerify(data));
          return;
        case TRANSACTION_STATE.PAYMENT_PROCESSING:
          if (stateApp.rfpMonitoring && isRfpPending(stateApp.transactionState)) {
            return;
          }
          yield put(transactionStatusPending(data));
          return;
        case TRANSACTION_STATE.FAILED:
          yield put(transactionStatusFailure(data));
          return;
        default:
          if (stateApp.rfpMonitoring && isRfpPending(stateApp.transactionState)) {
            return;
          }
          yield put(transactionStatusPending(data));
          return;
      }
    } else {
      yield put(transactionStatusFailure());
    }
  } catch (err) {}
}

function* workerSaga() {
  yield takeEvery(CONTINUE_TRANSACTION, continueTransactionCall);
  yield takeEvery(TRANSACTION_STATUS, transactionStatusCall);
}

export default function* appSaga() {
  yield all([workerSaga()]);
}
